import type { Chore } from "../lib/chores";

/** ══ 게시판 견본 — 패턴 페이지(`#/patterns`) 전용 ══
 *  원본(pr.b3x.app) 예시 항목 넷을 그대로 옮겼다. 일부러 긴 메모 · 문서 경로 · 링크 · 끝낸 것을 섞었다. */
export const PAT_CHORE_NOW = Date.parse("2026-10-31T06:00:00Z");

const base = {
  body: null,
  link: null,
  createdBy: "naru-s114",
  authorKind: "agent" as const,
  createdAt: "2026-10-30T22:10:00Z",
  updatedAt: "2026-10-30T22:10:00Z",
  doneAt: null,
  doneBy: null,
};

export const PAT_CHORES: Chore[] = [
  {
    ...base,
    id: "c-1",
    title: "GitHub 웹훅 설정(옵션)", // copy-ignore: 견본 자료
    body: "리포 Settings › Webhooks 에 /api/hooks/github 를 push · pull_request 로 등록하면 머지 감지가 폴링을 기다리지 않습니다.\n안 하면 5분마다 폴링으로 같은 일을 합니다.", // copy-ignore: 견본 자료
    link: "https://github.com/irolab-co/b3x-in/settings/hooks",
  },
  {
    ...base,
    id: "c-2",
    title: "구동 상태 패널 재확인", // copy-ignore: 견본 자료
    body: "make up 뒤 서버 화면의 나루 표식이 붙음으로 바뀌는지 봐 주세요.", // copy-ignore: 견본 자료
    link: "docs/decisions/servers.md",
    createdAt: "2026-10-31T03:40:00Z",
  },
  {
    ...base,
    id: "c-3",
    title: "GitHub App 인증 설정(옵션)", // copy-ignore: 견본 자료
    createdBy: "admin",
    authorKind: "human",
    createdAt: "2026-10-31T05:20:00Z",
  },
  {
    ...base,
    id: "c-4",
    title: "워크트리 정리", // copy-ignore: 견본 자료
    link: "make naru-gc",
    doneAt: "2026-10-31T05:50:00Z",
    doneBy: "admin",
  },
];
